export class ApiError extends Error {
  code: number;
  message: string;

  constructor(code: number, message: string) {
    super(message);
    this.code = code;
    this.message = message;
  }
}
export interface Pagination {
  currentPage: number;
  filteredPages: number | null;
  pageSize: number;
  processedCount: number;
  totalCount: number;
  totalPages: number;
}

export interface DocumentZipFilters {
  searchQuery?: string;
  processed?: boolean;
  extensions?: string[];
  startDate?: string;
  endDate?: string;
  documentTypes?: string[];
  documentThemes?: string[];
  hasKeyFacts?: boolean;
  hasRelevantFacts?: boolean;
}

export enum QueryEntity {
  ActiveRuns,
  ApideckAllConnections,
  ApideckSession,
  Case,
  CaseDocs,
  CaseDocsCount,
  CaseFacts,
  SubsetFacts,
  SubsetFactAllIds,
  SubsetInconsistencies,
  SubsetPersons,
  Subset,
  CaseIsPendingUpload,
  Chronologies,
  Chronology,
  ChronologyFacts,
  ChronologyVisualisation,
  Chunk,
  Doc,
  DocIds,
  DocSubsets,
  DocTypes,
  SubsetOverview,
  DocThemes,
  DocTotals,
  DocUnzip,
  DocSubsetFacts,
  DocumentChunkMatches,
  DraftCases,
  Fact,
  FailedDocs,
  Files,
  IncludedFactsCount,
  Inconsistencies,
  InconsistencyReport,
  InconsistencyReports,
  KeyFacts,
  Matter,
  Matters,
  MatterOverview,
  MatterUsers,
  MatterDocFilterValues,
  MatterDocsFilteredIds,
  MatterDocPersons,
  MatterDocsWithCases,
  MatterChronologies,
  Messages,
  Organisation,
  OrganisationById,
  Organisations,
  OrgUsageData,
  PersonalMatter,
  ProcessingDocs,
  PresignedGetDocumentImage,
  PresignedGetDocumentPDF,
  PresignedPost,
  RecentCases,
  RecentSubsets,
  GlobalRecentSubsets,
  RelativityDocumentCount,
  SubsetSuggestions,
  SubsetSuggestion,
  RelativityLists,
  RelativityWorkspaces,
  RelativityWorkspaceFields,
  RelativityFieldChoices,
  RelativityFieldMapping,
  MetadataFilterOptions,
  ConfiguredRelativityWorkspaces,
  RelativitySyncPreview,
  RelativitySyncStatus,
  Roles,
  Runs,
  Summary,
  CaseThemes,
  Threads,
  ThreadStatus,
  PublishedThreads,
  Transcript,
  TranscriptAudio,
  TranscriptInconsistencies,
  TranscriptSubfact,
  Transcripts,
  UploadPagesEstimate,
  UploadHistory,
  UserRoles,
  Users,
  UsersPaginated,
  User,
}
